<form
  class="needs-validation otp-form"
  novalidate
  [formGroup]="otpVerificationForm"
  (ngSubmit)="submitOtpVerificationForm()"
  #otpVerificationFormRef="ngForm"
>
  <div
    class="d-flex otp-inputs justify-content-center"
    [ngClass]="
      (otpVerificationForm.get('otpCode')?.hasError('required') ||
        otpVerificationForm.get('otpCode')?.hasError('minlength')) &&
      otpVerificationFormRef?.submitted
        ? 'mb-4'
        : 'mb-5'
    "
  >
    <div class="d-flex justify-content-center flex-column">
      <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="config"></ng-otp-input>

      @if (otpVerificationForm.get('otpCode')?.hasError('required') && otpVerificationFormRef?.submitted) {
        <span class="text-error">OTP is required</span>
      }

      @if (otpVerificationForm.get('otpCode')?.hasError('minlength') && otpVerificationFormRef?.submitted) {
        <span class="text-error"
          >Minimum {{ this.otpVerificationForm.get('otpCode')?.errors?.['minlength'].requiredLength }} characters are
          required.</span
        >
      }
    </div>
  </div>

  <div class="d-flex justify-content-center">
    <button type="submit" class="btn btn-primary mx-auto" [disabled]="isLoading()">
      Confirm OTP
      @if (isLoading()) {
        <span class="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>
      }
    </button>
  </div>
</form>
